export const listReport = {
  table: {
    date: '日付',
    total: '合計',
    reset: 'リセット',
    export: 'エクスポート',
    hour: '(単位　ｈ)',
  },
  pageHeader: {
    title: '工程別生産性管理',
  },
  filter: {
    filterDay: '日付別で表示',
    filterByRangeDay: '期間を指定して日別で表示',
    filterByTime: '期間を指定して集計を表示',
  },
  hooks: {
    selectRangeDateFail: '範囲の日付が無効です',
  },
}
